import {
  VectorStyleLayer,
  VectorStyle
} from '../../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../../twc-products';

const TWC_VOLCANIC_ASH_CLOUDS_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    id: 'volcanic-ash-clouds-fill',
    type: 'fill',
    source: 'twc',
    'source-layer': 'source-layer',
    minzoom: 0,
    maxzoom: 28,
    filter: ['all'],
    layout: {},
    paint: {
      'fill-color': '#808080',
      'fill-antialias': true,
      'fill-outline-color': '#CE1E2D',
      'fill-opacity': 0.3
    }
  },
  {
    id: 'volcanic-ash-clouds-outline',
    type: 'line',
    source: 'twc',
    'source-layer': 'source-layer',
    minzoom: 0,
    maxzoom: 28,
    filter: ['all'],
    layout: {},
    paint: {
      'line-color': '#CE1E2D',
      'line-width': 2
    }
  }
];

export const TWC_VOLCANIC_ASH_CLOUDS_VECTOR_STYLE: VectorStyle = {
  layers: TWC_VOLCANIC_ASH_CLOUDS_VECTOR_STYLE_LAYERS
};

export const VOLCANIC_ASH_CLOUDS_PRODUCT_DATA_VECTOR_TILE: TwcProduct = {
  id: 'volcanic-ash-clouds',
  defaultProductId: '6016',
  productName: 'Weather-Volcanic-ash-clouds-Concentration-Charts',
  label: 'Volcanic Ash Clouds',
  weatherType: 'Volcanic_ash_clouds_Concentration_Charts',
  description: 'TWC product (vector) - Volcanic Ash Concentration Charts',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 0,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    vectorTile: {
      vectorStyle: TWC_VOLCANIC_ASH_CLOUDS_VECTOR_STYLE
    }
  }
};
